import { orchestrator } from 'satcheljs';
import {
    resetFullComposeToChangeSeriesEditScope,
    presentDiscardClosureConfirmation,
    resetFullCompose,
} from 'owa-calendar-compose-form-actions';
import { getOriginalEvent } from 'owa-calendar-compose-store-manager';

orchestrator(resetFullComposeToChangeSeriesEditScope, actionMessage => {
    presentDiscardClosureConfirmation(actionMessage.formId, actionMessage.targetWindow, () => {
        resetFullCompose(
            actionMessage.formId,
            actionMessage.entrySource,
            { ItemId: getOriginalEvent(actionMessage.formId).ItemId },
            actionMessage.eventScope
        );
    });
});
